import React from "react";
import { FormComponent } from "../../../components/form/DynamicForm";
import { Form, Validators } from "../../../components/form/DynamicFormTs";
import { withRouter } from "react-router-dom";
import Http from "../../../Http";
import { objectAsParams } from "../../../helpers";
import {
  Dialog,
  Slide,
  Button
} from "@material-ui/core";
import DocumenacionDetalles from '../../Documentacion/Documentar/DocumentacionDetalles'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class Cotizacion extends FormComponent {

  guiaVals = {}

  componentDidMount() {
    this.FormConfig(
      {
        defaultUrl: "coizacion/one",
        saveUrl: "cotizacion/save",
        backUrl: "/Catalogo/Cotizaciones",
      },
      new Form(
        [
          Form.Field("select", "g_id_origen", "Origen", "", [Validators.required], 6),
          Form.Field("select", "g_id_destino", "Destino", "", [Validators.required], 6),
          Form.Section("CLIENTE"),
          Form.Field("hidden", "g_id_cliente", "", "", [Validators.required], 0),
          Form.Field("autocomplete", "guia_cliente_clave", "*Clave", "", [], 2),
          Form.Field("autocomplete", "guia_cliente_rsocial", "Cliente", "", [], 5),
          Form.Field("text", "guia_cliente_rfc", "RFC", "", [], 5, [], [], [], false, true),
          Form.Field("text", "guia_cliente_telefono", "Telefono", "", [], 4, [], [], [], false, true),
          Form.Field("text", "guia_cliente_domicilio", "Domicilio", "", [], 4, [], [], [], false, true),
          Form.Field("text", "guia_cliente_cp", "C.P.", "", [], 4, [], [], [], false, true),
          Form.Field("text", "guia_cliente_estado", "Estado", "", [], 4, [], [], [], false, true),
          Form.Field("text", "guia_cliente_ciudad", "Ciudad", "", [], 4, [], [], [], false, true),
          Form.Field("text", "guia_cliente_colonia", "Colonia", "", [], 4, [], [], [], false, true),
          Form.Section("REMITENTE"),
          Form.Field("text", "cp_remitente", "C.P.", "", [], 12),
          Form.Field("text", "estado_remitente", "Estado", "", [], 4),
          Form.Field("text", "ciudad_remitente", "Ciudad", "", [], 4),
          Form.Field("select", "id_colonia_remitente", "Colonia", "", [Validators.required], 4),
          Form.Section("DESTINATARIO"),
          Form.Field("text", "cp_destinatatario", "C.P.", "", [], 12),
          Form.Field("text", "estado_destinatario", "Estado", "", [], 4),
          Form.Field("text", "ciudad_destinatario", "Ciudad", "", [], 4),
          Form.Field("select", "id_colonia_destinatario", "Colonia", "", [Validators.required], 4),
          /** Detalles */
          Form.Field('hidden', 'g_id_tipo_precio', '', '1', [], 0),
          Form.Field('hidden', 'g_tipo_precio_valor', '', '', [], 0),
          Form.Field('hidden', 'paquetes', '', [], [], 0),
          Form.Field('hidden', 'g_observaciones', '', '', [], 0),
          Form.Field('hidden', 'g_dimensiones', '', '', [], 0),
          Form.Field('hidden', 'g_volumen_largo', '', '', [], 0),
          Form.Field('hidden', 'g_volumen_alto', '', '', [], 0),
          Form.Field('hidden', 'g_volumen_ancho', '', '', [], 0),
          Form.Field('hidden', 'g_peso_volumetrico', '', '', [], 0),
          Form.Field('hidden', 'g_peso_real', '', '', [], 0),
          Form.Field('hidden', 'g_piezas', '', '', [], 0),
          Form.Field('hidden', 'g_autoservicio', '', 0, [], 0),
          Form.Field('hidden', 'g_almacenaje', '', 0, [], 0),
          Form.Field('hidden', 'g_completo', '', 0, [], 0),
          Form.Field('hidden', 'id_grupo_embalaje', '', '1', [], 0),
        ],
        ["Detalles"],
        "Cotizacion"
      ),
      this.formData
    );
    if (this.props.match.params.id) this.LoadPreds();
  }

  formData = async (form) => {
    const params = {};
    let newForm = form;
    if (this.formCliRs) {
      params["cli_rs"] = this.formCliRs;
      this.formCliRs = null;
    }

    if (this.formCliClve) {
      params["cli_clve"] = this.formCliClve;
      this.formCliClve = null;
    }

    if (this.formCliId) {
      params["cli_id"] = this.formCliId;
    }

    if (!this.ods) {
      this.ods = true;
      params["ods"] = true;
    }

    if (this.cpRem) {
      params["cp_rem"] = this.cpRem;
      this.cpRem = false;
    }

    if (this.cpDest) {
      params["cp_dest"] = this.cpDest;
      this.cpDest = false;
    }

    const Res = await Http.get(`cotizacion/form?${objectAsParams(params)}`);
    if (!Res.error) {
      const { clientes, ods, destinatario, remitente } = Res.data;

      if (ods) {
        newForm = Form.FieldOptions(
          newForm,
          "g_id_origen",
          ods,
          "id",
          "label"
        );
        newForm = Form.FieldOptions(
          newForm,
          "g_id_destino",
          ods,
          "id",
          "label"
        );
      }

      if (clientes) {
        newForm = Form.FieldOptions(
          newForm,
          "guia_cliente_clave",
          clientes,
          "id",
          "cliente"
        );
        newForm = Form.FieldOptions(
          newForm,
          "guia_cliente_rsocial",
          clientes,
          "id",
          "cliente_rsocial"
        );
      }

      if (remitente) {
        this.setState({
          FormData: Form.Patch(
            this.state.FormData,
            {
              estado_remitente: remitente.estado,
              ciudad_remitente: remitente.ciudad,
            },
            false
          ),
        });
        newForm = Form.FieldOptions(
          newForm,
          "id_colonia_remitente",
          remitente.colonias,
          "id",
          "colonia"
        );
      }

      if (destinatario) {
        this.setState({
          FormData: Form.Patch(
            this.state.FormData,
            {
              estado_destinatario: destinatario.estado,
              ciudad_destinatario: destinatario.ciudad,
            },
            false
          ),
        });
        newForm = Form.FieldOptions(
          newForm,
          "id_colonia_destinatario",
          destinatario.colonias,
          "id",
          "colonia"
        );
      }
    }

    newForm = Form.ValueChange(newForm, {
      guia_cliente_clave: async (field) => {
        this.clienteChange(field, "formCliClve");
      },
      guia_cliente_rsocial: async (field) => {
        this.clienteChange(field, "formCliRs");
      },
      cp_remitente: async (field) => {
        field.Value.length > 4 && this.fieldChange(field, "cpRem");
      },
      cp_destinatatario: async (field) => {
        field.Value.length > 4 && this.fieldChange(field, "cpDest");
      },
    });
    return newForm;
  };

  clienteChange = async (field, variable) => {
    if (field.Value && !isNaN(field.Value)) {
      let Res = await Http.get(`cliente/one/${field.Value}`);
      if (!Res.error) {
        this.formCliId = Res.data.id;
        let formData = await this.formData(this.state.FormData);
        const {
          id,
          cliente_rfc,
          cliente_telefono,
          cliente_domicilio,
          cliente_cp,
          Ciudad,
          Estado,
          Colonia,
        } = Res.data;
        this.setState({
          FormData: Form.Patch(
            formData,
            {
              g_id_cliente: id,
              guia_cliente_clave: id + "",
              guia_cliente_rsocial: id + "",
              guia_cliente_rfc: cliente_rfc,
              guia_cliente_telefono: cliente_telefono,
              guia_cliente_domicilio: cliente_domicilio,
              guia_cliente_colonia: Colonia.colonia,
              guia_cliente_ciudad: Ciudad.ciudad,
              guia_cliente_estado: Estado.estado,
              guia_cliente_cp: cliente_cp,
            },
            false
          ),
        });
      }
    } else {
      this[variable] = field.ValueAt;
      this.setState({
        FormData: await this.formData(this.state.FormData),
      });
    }
  };

  fieldChange = async (field, variable) => {
    this[variable] = field.Value;
    this.setState({ FormData: await this.formData(this.state.FormData) });
  };

  onSubmit = async (i, vals) => {
    this.guiaVals = vals;
    this.guiaVals.paquetes = [];
    this.guiaVals.g_id_tipo_precio = "1";
    this.guiaVals.id_grupo_embalaje = "1"
    this.setState({ detallesOpen: true });
  };

  detallesClose = () => {
    this.setState({ detallesOpen: false });
  }

  onSave = async ({ guia, paquetes, cobrosAplicados, serviciosIncluidos }) => {
    var Res = await Http.post(`cotizacion/save`, { 
      guia,
      paquetes, 
      cobrosAplicados,
      serviciosIncluidos
    }, true, 'arraybuffer');
    if (!Res.error) {
      const blob = new Blob([Res], { type: 'application/pdf' })
      const url = URL.createObjectURL(blob);
      window.open(url, 'Cotizacion', 'width=1050,height=800');
      this.setState({
        FormData: Form.Reset(this.state.FormData),
        detallesOpen: false,
      });
    }
  }

  render() {
    const { detallesOpen } = this.state;

    return (
      <div>
        <this.FormRender />

        {/* Modal Detalles Documetnacion */}
        <div>
          <Dialog
            fullScreen
            open={!!detallesOpen}
            onClose={this.detallesClose}
            TransitionComponent={Transition}
          >
            <div style={{ textAlign: "right" }}>
              <Button onClick={this.detallesClose}>REGRESAR</Button>
            </div>
            <div>
              <DocumenacionDetalles guia={this.guiaVals} onSave={this.onSave} noDetalles />
            </div>
          </Dialog>
        </div>
      </div>
    );
  }
}

export default withRouter(Cotizacion);
